import {
  BillOutlineIcon,
  PaymentOutlineIcon,
  PosOutlineIcon,
  ShippingOutlineIcon,
} from 'components/Icon';
import {
  BoxOutlineIcon,
  ForecastReportOutlineIcon,
} from 'components/Icon/Menu';

export const BILL_TYPE = [
  {
    code: 'NORMAL',
    name: 'Phiếu xuất kho',
    fileName: 'phieu_xuat_kho#',
    icon: <BoxOutlineIcon />,
  },
  {
    code: 'PAYMENT',
    name: 'Hóa đơn bán hàng',
    fileName: 'hoa_don_ban_hang#',
    icon: <PaymentOutlineIcon />,
  },

  {
    code: 'DELIVERY',
    name: 'Hóa đơn giao hàng',
    fileName: 'hoa_don_giao_hang#',
    icon: <ShippingOutlineIcon />,
  },
  {
    code: 'WAREHOUSE',
    name: 'Phiếu sơ chế',
    fileName: 'phieu_so_che#',
    icon: <ForecastReportOutlineIcon />,
  },
  {
    code: 'A4',
    name: 'Hóa đơn điện tử',
    fileName: 'hoa_don_dien_tu#',
    icon: <BillOutlineIcon />,
  },
  {
    code: 'K58',
    name: 'Hóa đơn POS K58',
    fileName: 'hoa_don_pos_k58#',
    icon: <PosOutlineIcon />,
  },
  {
    code: 'K80',
    name: 'Hóa đơn POS K80',
    fileName: 'hoa_don_pos_k80#',
    icon: <PosOutlineIcon />,
  },
];

export const dataSettingQuantityVisible = [
  {
    title: '',
    name: {
      isVisibleCustomerQuantity: 'Số lượng đặt',
      isVisibleSupplierQuantity: 'Số lượng chốt',
      isVisibleSupplierDelivered: 'Số lượng giao',
      isVisibleCustomerReceived: 'Số lượng nhận',
    },
    type: 'check',
  },
];

export const dataSettingOrderInfoVisible = [
  {
    title: 'Nhà cung cấp hiển thị',
    name: {
      isCentral: 'Trung tâm',
      isSupplier: 'Chi nhánh',
    },
    type: 'radio',
  },
  {
    title: 'Logo hiển thị',
    name: {
      isAvatar: 'Logo biểu tượng',
      isAvatarText: 'Logo đầy đủ',
    },
    type: 'radio',
  },
  {
    title: 'Thông tin đơn hàng',
    name: {
      isVisibleLogo: 'Logo',
      isVisibleQRCode: 'QR Code đơn hàng',
      isVisibleOrderCode: 'Mã đơn hàng',
      isVisibleTotalProducts: 'Tổng sản phẩm',
      isVisibleProduct: 'Danh sách sản phẩm',
      isVisibleCustomerOrderNote: 'Ghi chú KH',
      isVisibleSupplierOrderNote: 'Ghi chú NCC',
    },
    type: 'check',
  },
  {
    title: 'Thông tin khách hàng',
    name: {
      isVisibleCustomer: 'Khách hàng',
      isVisibleCustomerName: 'Họ và tên',
      isVisibleCustomerPhoneNumber: 'Số điện thoại',
      isVisibleCustomerAddress: 'Địa chỉ',
    },
    type: 'check',
  },
  {
    title: 'Thông tin sản phẩm',
    name: {
      isVisibleProductCategory: 'Danh mục',
      isVisibleProductUnit: 'Đơn vị',
      isVisibleProductPrice: 'Tiền sản phẩm',
      isVisibleCustomerOrderItemNote: 'Ghi chú KH',
      isVisibleSupplierOrderItemNote: 'Ghi chú NCC',
    },
    type: 'check',
  },
];

export const dataSupplierSettingOrderInfoVisible = [
  {
    title: 'Nhà cung cấp hiển thị',
    name: {
      isCentral: 'Trung tâm',
      isSupplier: 'Chi nhánh',
    },
    type: 'radio',
  },
  {
    title: 'Logo hiển thị',
    name: {
      isAvatar: 'Logo biểu tượng',
      isAvatarText: 'Logo đầy đủ',
    },
    type: 'radio',
  },
];

export const dataSupplierSettingOrderK58InfoVisible = [
  {
    title: 'Nhà cung cấp hiển thị',
    name: {
      isCentral: 'Trung tâm',
      isSupplier: 'Chi nhánh',
    },
    type: 'radio',
  },
];

export const dataSettingBillInfoVisible = [
  {
    title: 'Nhà cung cấp hiển thị',
    name: {
      isCentral: 'Trung tâm',
      isSupplier: 'Chi nhánh',
    },
    type: 'radio',
  },
  {
    title: 'Logo hiển thị',
    name: {
      isAvatar: 'Logo biểu tượng',
      isAvatarText: 'Logo đầy đủ',
    },
    type: 'radio',
  },
  {
    title: 'Thông tin hoá đơn',
    name: {
      isVisibleLogo: 'Logo',
      isVisiblePaymentQRCode: 'QR Code thanh toán',
      isVisiblePaymentInfo: 'Thông tin thanh toán',
      isVisibleDeliveryFee: 'Phí giao hàng',
      isVisibleDeliveryFeeWhenEmpty: 'Phí giao hàng khi bằng 0',
      isVisiblePriceDetail: 'Chi tiết tiền',
      isVisibleSignature: 'Chữ ký',
    },
    type: 'check',
  },
  {
    title: 'Thông tin khách hàng',
    name: {
      isVisibleCustomer: 'Khách hàng',
      isVisibleCustomerPhoneNumber: 'Số điện thoại',
      isVisibleCustomerAddress: 'Địa chỉ',
    },
    type: 'check',
  },
  {
    title: 'Thông tin nhà cung cấp',
    name: {
      isVisibleSupplier: 'Nhà cung cấp',
      isVisibleSupplierPhoneNumber: 'Số điện thoại',
      isVisibleSupplierAddress: 'Địa chỉ',
      isVisibleSupplierCashier: 'Thu ngân',
    },
    type: 'check',
  },
];

export const defaultSettingQuantityVisible = {
  isVisibleCustomerQuantity: true,
  isVisibleSupplierQuantity: true,
  isVisibleSupplierDelivered: true,
  isVisibleCustomerReceived: true,
};

export const defaultSettingOrderInfoVisible = {
  isCentral: true,
  isSupplier: false,
  isAvatar: true,
  isAvatarText: false,
  isVisibleQRCode: true,
  isVisibleOrderCode: true,
  isVisibleCustomerOrderNote: true,
  isVisibleSupplierOrderNote: true,
  isVisibleCustomer: true,
  isVisibleCustomerName: true,
  isVisibleCustomerPhoneNumber: true,
  isVisibleCustomerAddress: true,
  isVisibleTotalProducts: false,
  isVisibleProduct: true,
  isVisibleProductCategory: true,
  isVisibleProductUnit: true,
  isVisibleProductPrice: true,
  isVisibleCustomerOrderItemNote: true,
  isVisibleSupplierOrderItemNote: true,
};

export const defaultSettingBillInfoVisible = {
  isVisibleLogo: true,
  isVisiblePaymentQRCode: true,
  isVisiblePaymentInfo: true,
  isVisibleDeliveryFee: true,
  isVisibleDeliveryFeeWhenEmpty: false,
  isVisiblePriceDetail: true,
  isVisibleCustomer: true,
  isVisibleCustomerPhoneNumber: true,
  isVisibleCustomerAddress: true,
  isVisibleSupplier: true,
  isVisibleSupplierPhoneNumber: true,
  isVisibleSupplierAddress: true,
  isVisibleSupplierCashier: true,
  isVisibleSignature: true,
};

export interface SettingBillInfoVisibleInterface {
  isVisibleLogo?: boolean;
  isVisiblePaymentQRCode?: boolean;
  isVisiblePaymentInfo?: boolean;
  isVisibleDeliveryFee?: boolean;
  isVisibleDeliveryFeeWhenEmpty?: boolean;
  isVisiblePriceDetail?: boolean;
  isVisibleCustomer?: boolean;
  isVisibleCustomerPhoneNumber?: boolean;
  isVisibleCustomerAddress?: boolean;
  isVisibleSupplier?: boolean;
  isVisibleSupplierPhoneNumber?: boolean;
  isVisibleSupplierAddress?: boolean;
  isVisibleSupplierCashier?: boolean;
  isVisibleSignature?: boolean;
}
